"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DefaultCardStyles = void 0;
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  DefaultCardStyles = theme => {
    return {
      alignItems: "center",
      alignSelf: "stretch",
      background: "#333",
      backgroundPosition: "center",
      backgroundSize: "cover",
      boxShadow: "unset",
      color: "white",
      display: "flex",
      flex: "0 0 33%",
      flexDirection: "column",
      fontSize: "2rem",
      justifyContent: "center",
      margin: "0 0 0 auto",
      minWidth: "33%",
      padding: "3rem",
      textAlign: "center",
      "h1,h2,h3,h4,h5,h6": {
        fontFamily: theme.fontFamilies.semiBold,
        fontSize: "2.6rem"
      },
      "> *:last-child a": {
        background: "white",
        border: `0.1rem solid ${theme.palette.primary.main}`,
        borderRadius: "0.5rem",
        color: theme.palette.primary.main,
        display: "inline-flex",
        fontFamily: theme.fontFamilies.bold,
        fontSize: "1.6rem",
        margin: "2rem 0 0",
        padding: "1.4rem 2.5rem",
        textAlign: "center",
        textDecoration: "none",
        textTransform: "uppercase",
        "&:hover,&:focus-visible,&:active": {
          textDecoration: "underline"
        }
      }
    };
  };

/**
 * Header Navigation Ad Component
 *
 * @visibleName Header Ad
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.DefaultCardStyles = DefaultCardStyles;
const HeaderAd = props => {
  const {
      children = "Header Ad",
      customClassNames,
      customCardStyles = {},
      customTheme = {},
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    adClasses = (0, _classnames.default)({
      "header__ad": true,
      [`${customClassNames}`]: customClassNames
    }),
    adStyles = merge(DefaultCardStyles(theme), customCardStyles);
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    className: adClasses,
    "data-testid": testId,
    sx: adStyles
  }, children);
};

// Define propTypes;
HeaderAd.propTypes = {
  /** Contents of ad body (Default Value: "Header Ad") */
  children: _propTypes.default.any,
  /** Custom styles for ad (Default Value: {}) */
  customCardStyles: _propTypes.default.object,
  /** Custom classname(s) for ad */
  customClassNames: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string])
};

// Export component as default;
var _default = exports.default = HeaderAd;